var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9861 12.0303H17.002C14.2366 12.0303 11.9964 14.275 12.002 17.0403L12.0139 22.99C12.0194 25.7475 14.2564 27.98 17.0139 27.98H17.5081L17.1514 30.8264C17.097 31.2605 17.587 31.5502 17.9411 31.2933L22.5081 27.98H26.998C29.7634 27.98 32.0036 25.7353 31.998 22.97L31.9861 17.0202C31.9806 14.2627 29.7436 12.0303 26.9861 12.0303Z",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 21.3652V21.1553C21.9998 20.4753 22.4198 20.1153 22.8398 19.8253C23.2498 19.5453 23.6598 19.1853 23.6598 18.5253C23.6598 17.6053 22.9198 16.8652 21.9998 16.8652C21.0798 16.8652 20.3398 17.6053 20.3398 18.5253",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9955 23.7559H22.0045",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnHelp);
export default __webpack_public_path__ + "static/media/btn_help.467cd801b28965b2187685c223f7a9a4.svg";
export { ForwardRef as ReactComponent };